import * as React from 'react'
import { useFormikContext } from 'formik'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Stack from '@mui/material/Stack'

import { EditableCustomField } from '@user/components/CustomFields'

import type { RequiredFieldsFormModel } from './typings'
import type { UseData } from './hooks/useData'

type Props = {
  data: UseData
  onClose: () => void
}

export function RequiredFieldsForm(props: Props) {
  const { data, onClose } = props
  const { loading, missingFields, settingByFieldId } = data

  const { isSubmitting, isValid, submitForm } =
    useFormikContext<RequiredFieldsFormModel>()

  return (
    <>
      <DialogContent sx={{ px: 3, pb: 2 }}>
        {loading ? (
          <CircularProgress />
        ) : (
          <Stack spacing={2} sx={{ pt: 2 }}>
            {missingFields.map((field) => (
              <EditableCustomField
                key={field.id}
                field={field}
                fieldSetting={settingByFieldId.get(field.id)}
                hideOptional={false}
              />
            ))}
          </Stack>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pt: 1, pb: 3 }}>
        <Button
          size="large"
          onClick={onClose}
          data-test-id="required-fields-cancel-button"
        >
          Cancel
        </Button>
        <Button
          size="large"
          variant="contained"
          disabled={!isValid || isSubmitting}
          onClick={submitForm}
          data-test-id="required-fields-save-button"
        >
          Save
        </Button>
      </DialogActions>
    </>
  )
}

RequiredFieldsForm.displayName = 'RequiredFieldsForm'
